import instance from "./../axios";
import { PokemonsPageResponseI } from "interfaces/pokemonsPageRequest.interface";
import { FiltersInfoI } from "interfaces";

export async function getPokemons(
  search: string,
  formData: {},
  page?: number
): Promise<PokemonsPageResponseI> {
  const response = await instance.post(
    `/api/api/get_pokemons/?search=${search}&page=${page}`,
    formData
  );

  if (response.status === 200) {
    return response.data;
  } else {
    throw new Error("Error fetching pokemons");
  }
}

export async function getFiltersInfo(): Promise<Omit<FiltersInfoI, "others">> {
  const response = await instance.get(`/api/api/get_filters_info`);

  if (response.status === 200) {
    return response.data;
  } else {
    throw new Error("Error fetching filters info");
  }
}

export async function getPokemonProfile(pokemonIdName: string) {
  const response = await instance.get(
    `/api/api/get_pokemon_profile/?id_name=${pokemonIdName}`
  );

  if (response.status === 200) {
    return response.data;
  } else {
    throw new Error("Error fetching pokemons");
  }
}

export async function getPokemonSearchBar(searchTerm: string) {
  const response = await instance.get(
    `/api/api/get_pokemon_autocomplete/?research=${searchTerm}`
  );

  if (response.status === 200) {
    return response.data;
  } else {
    throw new Error("Error fetching pokemons");
  }
}
